import { get } from "../../";

export function autocomplete({ query = "", limit = 100 }) {
  return get("tickets/views/columns/autocomplete", {
    query,
    limit,
  });
}
